export const twoFactorCookieName = 'TwoFactorRequestOn';
export const twoFactorCookieValue =
  'DisableTwoFactorRequestOnThisDeviceFor90Days';
export const twoFactorCookieDuration = 30;
